module.exports = __webpack_public_path__ + "media/images/img-realestate-6-85c5e86a.png";